import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchDmEvents, type DmEventItem } from '../services/dmEvents';

export function useDmEvents(patientId: string | undefined, dmId: number | null | undefined) {
    const query = useInfiniteQuery({
        queryKey: ['v2/patients', patientId, 'monitoring', 'events'],
        queryFn: ({ pageParam }) => fetchDmEvents(patientId!, 20, pageParam),
        initialPageParam: undefined as string | undefined,
        getNextPageParam: (lastPage) => lastPage.cursor.after ?? undefined,
        enabled: !!patientId && !!dmId,
        staleTime: 5 * 60 * 1000,
        retry: 1
    });

    const items: DmEventItem[] = useMemo(
        () => query.data?.pages.flatMap((page) => page.items) ?? [],
        [query.data]
    );

    return {
        items,
        isLoading: query.isLoading,
        isFetchingNextPage: query.isFetchingNextPage,
        hasNextPage: query.hasNextPage,
        fetchNextPage: query.fetchNextPage,
        error: query.error
    };
}
